<template>
  <b-button variant="light" @click="back()">
    Cancel
  </b-button>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
